import { defineComponent as _defineComponent } from 'vue'

  import { Document } from "@/types/CustomerLotDetails";
  import { formatDateMonthDayYear } from "@/helpers/date";
  import DocumentItemWithSlot from "@/components/ui/DocumentItemWithSlot.vue";

  interface Props {
    contracts: Document[];
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerLotContracts',
  props: {
    contracts: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, get Document() { return Document }, get formatDateMonthDayYear() { return formatDateMonthDayYear }, DocumentItemWithSlot }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})